// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Do not edit directly!,
 * this is an auto-generated file and its content will be overwritten.
 */

:host {
  --color-blue-10: #eff4ff;
  --color-blue-20: #dfe9ff;
  --color-blue-40: #bfd2ff;
  --color-blue-80: #80a5ff;
  --color-blue-100: #608fff;
  --color-blue-120: #4d72cc;
  --color-blue-140: #3a5699;
  --color-green-10: #ebf8ef;
  --color-green-20: #d7f1df;
  --color-green-80: #60c87f;
  --color-green-100: #38ba5f;
  --color-green-120: #2d954c;
  --color-green-140: #227039;
  --color-grey-2: #fbfbfb;
  --color-grey-3: #f8f8f8;
  --color-grey-6: #f2f2f2;
  --color-grey-9: #ebebeb;
  --color-grey-12: #e4e4e4;
  --color-grey-20: #d3d3d3;
  --color-grey-30: #bdbdbd;
  --color-grey-40: #a7a7a7;
  --color-grey-50: #919191;
  --color-grey-60: #7a7a7a;
  --color-grey-70: #646464;
  --color-grey-80: #4e4e4e;
  --color-grey-90: #383838;
  --color-grey-100: #222222;
  --color-red-10: #fbebeb;
  --color-red-20: #f7d7d7;
  --color-red-80: #e16060;
  --color-red-100: #d93838;
  --color-red-120: #ae2d2d;
  --color-red-140: #822222;
  --color-white: #ffffff;
  --color-yellow-10: #fef9e9;
  --color-yellow-20: #fef4d3;
  --color-yellow-30: #fdefbc;
  --color-yellow-80: #f9d34d;
  --color-yellow-100: #f8c821;
  --color-yellow-120: #c6a01a;
  --color-yellow-140: #957814;
  --color-gray-organic: #f7f9fa;
  --color-blue-organic: #5981e3;
  --color-text-organic: #818181;
  --font-family-display: 'Nunito Sans';
  --font-family-system: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',
    'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  --font-size-10: 0.625rem;
  --font-size-11: 0.6875rem;
  --font-size-12: 0.75rem;
  --font-size-14: 0.875rem;
  --font-size-16: 1rem;
  --font-size-18: 1.125rem;
  --font-size-20: 1.25rem;
  --font-size-24: 1.5rem;
  --font-size-32: 2rem;
  --font-size-34: 2.125rem;
  --font-size-48: 3rem;
  --font-weight-200: 200;
  --font-weight-300: 300;
  --font-weight-400: 400;
  --font-weight-500: 500;
  --font-weight-600: 600;
  --font-weight-700: 700;
  --font-weight-800: 800;
  --font-weight-900: 900;
  --letter-spacing-1: 1px;
  --letter-spacing-half: 0.5px;
  --line-height-100: 100%;
  --line-height-125: 125%;
  --line-height-150: 150%;
  --size-1: 0.0625rem;
  --size-2: 0.125rem;
  --size-4: 0.25rem;
  --size-6: 0.375rem;
  --size-8: 0.5rem;
  --size-10: 0.625rem;
  --size-11: 0.6875rem;
  --size-12: 0.75rem;
  --size-14: 0.875rem;
  --size-16: 1rem;
  --size-18: 1.125rem;
  --size-20: 1.25rem;
  --size-22: 1.375rem;
  --size-24: 1.5rem;
  --size-26: 1.625rem;
  --size-28: 1.75rem;
  --size-30: 1.875rem;
  --size-32: 2rem;
  --size-34: 2.125rem;
  --size-36: 2.25rem;
  --size-38: 2.375rem;
  --size-40: 2.5rem;
  --size-48: 3rem;
  --size-60: 3.75rem;
  --size-72: 4.5rem;
  --size-full: 100%;
  --size-half: 50%;
  --size-quarter: 25%;
  --space-0: 0;
  --space-2: 0.125rem;
  --space-4: 0.25rem;
  --space-8: 0.5rem;
  --space-12: 0.75rem;
  --space-16: 1rem;
  --space-20: 1.25rem;
  --space-24: 1.5rem;
  --space-32: 2rem;
  --space-40: 2.5rem;
  --space-48: 3rem;
  --space-60: 3.75rem;
  --space-72: 4.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/cookie-banner/implementations/hotmart-home/hotmart-home-tokens.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,oCAAoC;EACpC;wEACsE;EACtE,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;EACxB,oBAAoB;EACpB,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["/**\n * Do not edit directly!,\n * this is an auto-generated file and its content will be overwritten.\n */\n\n:host {\n  --color-blue-10: #eff4ff;\n  --color-blue-20: #dfe9ff;\n  --color-blue-40: #bfd2ff;\n  --color-blue-80: #80a5ff;\n  --color-blue-100: #608fff;\n  --color-blue-120: #4d72cc;\n  --color-blue-140: #3a5699;\n  --color-green-10: #ebf8ef;\n  --color-green-20: #d7f1df;\n  --color-green-80: #60c87f;\n  --color-green-100: #38ba5f;\n  --color-green-120: #2d954c;\n  --color-green-140: #227039;\n  --color-grey-2: #fbfbfb;\n  --color-grey-3: #f8f8f8;\n  --color-grey-6: #f2f2f2;\n  --color-grey-9: #ebebeb;\n  --color-grey-12: #e4e4e4;\n  --color-grey-20: #d3d3d3;\n  --color-grey-30: #bdbdbd;\n  --color-grey-40: #a7a7a7;\n  --color-grey-50: #919191;\n  --color-grey-60: #7a7a7a;\n  --color-grey-70: #646464;\n  --color-grey-80: #4e4e4e;\n  --color-grey-90: #383838;\n  --color-grey-100: #222222;\n  --color-red-10: #fbebeb;\n  --color-red-20: #f7d7d7;\n  --color-red-80: #e16060;\n  --color-red-100: #d93838;\n  --color-red-120: #ae2d2d;\n  --color-red-140: #822222;\n  --color-white: #ffffff;\n  --color-yellow-10: #fef9e9;\n  --color-yellow-20: #fef4d3;\n  --color-yellow-30: #fdefbc;\n  --color-yellow-80: #f9d34d;\n  --color-yellow-100: #f8c821;\n  --color-yellow-120: #c6a01a;\n  --color-yellow-140: #957814;\n  --color-gray-organic: #f7f9fa;\n  --color-blue-organic: #5981e3;\n  --color-text-organic: #818181;\n  --font-family-display: 'Nunito Sans';\n  --font-family-system: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',\n    'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  --font-size-10: 0.625rem;\n  --font-size-11: 0.6875rem;\n  --font-size-12: 0.75rem;\n  --font-size-14: 0.875rem;\n  --font-size-16: 1rem;\n  --font-size-18: 1.125rem;\n  --font-size-20: 1.25rem;\n  --font-size-24: 1.5rem;\n  --font-size-32: 2rem;\n  --font-size-34: 2.125rem;\n  --font-size-48: 3rem;\n  --font-weight-200: 200;\n  --font-weight-300: 300;\n  --font-weight-400: 400;\n  --font-weight-500: 500;\n  --font-weight-600: 600;\n  --font-weight-700: 700;\n  --font-weight-800: 800;\n  --font-weight-900: 900;\n  --letter-spacing-1: 1px;\n  --letter-spacing-half: 0.5px;\n  --line-height-100: 100%;\n  --line-height-125: 125%;\n  --line-height-150: 150%;\n  --size-1: 0.0625rem;\n  --size-2: 0.125rem;\n  --size-4: 0.25rem;\n  --size-6: 0.375rem;\n  --size-8: 0.5rem;\n  --size-10: 0.625rem;\n  --size-11: 0.6875rem;\n  --size-12: 0.75rem;\n  --size-14: 0.875rem;\n  --size-16: 1rem;\n  --size-18: 1.125rem;\n  --size-20: 1.25rem;\n  --size-22: 1.375rem;\n  --size-24: 1.5rem;\n  --size-26: 1.625rem;\n  --size-28: 1.75rem;\n  --size-30: 1.875rem;\n  --size-32: 2rem;\n  --size-34: 2.125rem;\n  --size-36: 2.25rem;\n  --size-38: 2.375rem;\n  --size-40: 2.5rem;\n  --size-48: 3rem;\n  --size-60: 3.75rem;\n  --size-72: 4.5rem;\n  --size-full: 100%;\n  --size-half: 50%;\n  --size-quarter: 25%;\n  --space-0: 0;\n  --space-2: 0.125rem;\n  --space-4: 0.25rem;\n  --space-8: 0.5rem;\n  --space-12: 0.75rem;\n  --space-16: 1rem;\n  --space-20: 1.25rem;\n  --space-24: 1.5rem;\n  --space-32: 2rem;\n  --space-40: 2.5rem;\n  --space-48: 3rem;\n  --space-60: 3.75rem;\n  --space-72: 4.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
